export default __webpack_public_path__ + "static/media/like.be1d10c9.png";